import clsx from 'clsx';
import {cloneElement, ReactElement} from 'react';

export interface SidenavProps {
  children: ReactElement<{className: string; isCompactMode?: boolean}>;
  position?: 'left' | 'right';
  isMobileSideBar?: boolean;
  className?: string;
  overlayPosition?: string;
  overflow?: string;
}

export function DashboardSidenav({
  position = 'left',
  children,
  isMobileSideBar,
  className = '',
  overlayPosition = '',
  overflow = '',
}: SidenavProps) {
  return (
    <div
      className={clsx(
        className,
        position === 'left'
          ? 'dashboard-grid-sidenav-left'
          : 'dashboard-grid-sidenav-right',
        isMobileSideBar ? 'transition-all duration-150 ease-in-out will-change-[width] w-240' : 'will-change-[width] w-240',
        overflow,
        `${overlayPosition} bottom-0 top-0 z-20 shadow-2xl`,
        position === 'left' && 'left-0',
        position === 'right' && 'right-0',
      )}
    >
      {cloneElement(children, {
        className: clsx(
          children.props.className,
          'w-full h-full',
          !isMobileSideBar && 'compact-scrollbar',
        ),
        isCompactMode: !isMobileSideBar,
      })}
    </div>
  );
}
